import { AppState } from '../states/appState'
import { r360Api } from '@/app/services/services'
import {
    News,
    NewsAddCommentActionPayload,
    NewsReactionType,
    NewsTabBarId,
    NewsUpdateTotalReactionsActionPayload,
} from '@models/news'
import moment from 'moment'
import { dateFormat } from '@/app/utils/localization/intlHelper'
import { ActivitiesFiltersProps } from '@/app/models/activities'
import { NEWS_REDUCER_NAMESPACE } from '../reducers/news'
import { commentsActions, UserHelper } from '@Techedge/digitalportal-shared'

export const Actions = {
    GET_NEWS_REQUEST: 'GET_NEWS_REQUEST',
    GET_NEWS_FAILURE: 'GET_NEWS_FAILURE',
    GET_NEWS_SUCCESS: 'GET_NEWS_SUCCESS',
    GET_MORE_NEWS_REQUEST: 'GET_MORE_NEWS_REQUEST',
    GET_MORE_NEWS_FAILURE: 'GET_MORE_NEWS_REQUEST',
    GET_MORE_NEWS_SUCCESS: 'GET_MORE_NEWS_SUCCESS',
    GET_NEWS_DETAIL_SUCCESS: 'GET_NEWS_DETAIL_SUCCESS',
    SET_NEWS_REACTION_REQUEST: 'SET_NEWS_REACTION_REQUEST',
    SET_NEWS_REACTION_FAILURE: 'SET_NEWS_REACTION_FAILURE',
    SET_FILTERS: 'SET_FILTERS',
    ADD_COMMENT: 'ADD_COMMENT',
    SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
    SET_NEWS_DETAILS: 'SET_NEWS_DETAILS',
    ORDER_RANDOM_NEWS: 'ORDER_RANDOM_NEWS',
    UPDATE_TOTAL_REACTIONS: 'UPDATE_TOTAL_REACTIONS',
    COPY_LINK_TO_CLIPBOARD_SUCCESS: 'COPY_LINK_TO_CLIPBOARD_SUCCESS'
}

// GET NEWS

export const getNewsRequest = () => {
    return { type: Actions.GET_NEWS_REQUEST }
}
export const getMoreNewsRequest = () => {
    return { type: Actions.GET_MORE_NEWS_REQUEST }
}

export const reactionToNewsRequest = (newsId: string) => {
    return { type: Actions.SET_NEWS_REACTION_REQUEST, newsId }
}

export const getNewsError = (error?: any) => {
    return { type: Actions.GET_NEWS_FAILURE, error }
}

export const getMoreNewsError = (error?: any) => {
    return { type: Actions.GET_MORE_NEWS_FAILURE, error }
}

export const reactionToNewsError = (newsId: string, error?: string) => {
    return { type: Actions.SET_NEWS_REACTION_FAILURE, error, newsId }
}

export const getNewsSuccess = (news: any, totalNews: number) => {
    return {
        type: Actions.GET_NEWS_SUCCESS,
        news,
        totalNews,
    }
}

export const getMoreNewsSuccess = (news: any, totalNews: number) => {
    return {
        type: Actions.GET_MORE_NEWS_SUCCESS,
        news,
        totalNews,
    }
}

export const getNewsReactionsSuccess = (newsReactions: any, newsId: string) => {
    return {
        type: Actions.GET_NEWS_DETAIL_SUCCESS,
        newsReactions,
        newsId,
    }
}

export const getNews = (customFilters?: ActivitiesFiltersProps, moreNews?: boolean) => {
    return (dispatch: any, getState: any) => {
        if (moreNews) {
            dispatch(getMoreNewsRequest())
        } else {
            dispatch(getNewsRequest())
        }
        let filters = (getState() as AppState).newsReducer.filters
        filters.type = {
            value: ['news'],
        }
        filters.more_information = true
        if (customFilters) {
            filters = {
                ...filters,
                ...customFilters,
            }
        }
        dispatch(setFilters(filters))
        r360Api
            .GetActivities(filters)
            .then((res: any) => {
                if (res && res.data && res.data.activities) {
                    let tmpNews = res.data.activities.map((a: any) => {
                        let reactionTypes = []
                        if (a.reactions) {
                            a.reactions.forEach((r) => {
                                const selReact = reactionTypes.find(
                                    (rt: NewsReactionType) => r.reaction === rt
                                )

                                if (!selReact) reactionTypes.push(r.reaction)
                            })
                        }
                        return {
                            id: a.id,
                            author: {
                                name: a.create_user_info.name,
                                lastname: a.create_user_info.lastname,
                                nickname: a.userId,
                                alias: a.create_user_info.nickname,
                                avatar: a.create_user_info.attachment?.url || '',
                            },
                            creationDate: moment(a.start_date).format(dateFormat),
                            type: a.type,
                            typeKey: a.module,
                            content: a.content,
                            title: a.project_name,
                            store_ids: a.store_ids,
                            hashtagList: [],
                            imageList: a?.coverUrl
                                ? [`${a.coverUrl}`]
                                : [] /* [`${process.env.SMARTLY_URL}/styleguide/assets/images/news-1.jpg`] */,
                            enableCommentsAndReactions: a.enableCommentsAndReactions,
                            totalComments: a.message_count,
                            reactions: {
                                userReaction: a.reactions?.find(
                                    (r) => r.userInfo.userId === UserHelper._shared().user().user_id
                                )?.reaction,
                                types: reactionTypes,
                                count: a.reactions?.length,
                            },
                        }
                    })
                    if (moreNews) {
                        dispatch(getMoreNewsSuccess(tmpNews, res.data?.total_activities))
                    } else {
                        dispatch(getNewsSuccess(tmpNews, res.data?.total_activities))
                    }
                } else {
                    if (moreNews) {
                        dispatch(getMoreNewsError())
                    } else {
                        dispatch(getNewsError())
                    }
                }
            })
            .catch((error: Error) => {
                if (moreNews) {
                    dispatch(getMoreNewsError())
                } else {
                    dispatch(getNewsError())
                }
            })
    }
}

export const getNewsReactions = (id: string) => {
    return (dispatch: any, getState: any) => {
        r360Api
            .GetActivityDetail(id)
            .then((res: any) => {
                if (res && res.data) {
                    let a = res.data
                    let reactionTypes = []
                    if (a.reactions) {
                        a.reactions.forEach((r) => {
                            const selReact = reactionTypes.find(
                                (rt: NewsReactionType) => r.reaction === rt
                            )

                            if (!selReact) reactionTypes.push(r.reaction)
                        })
                    }
                    let tmpNewsReactions = {
                        userReaction: a.reactions?.find(
                            (r) => r.userInfo.userId === UserHelper._shared().user().user_id
                        )?.reaction,
                        types: reactionTypes,
                        count: a.reactions?.length,
                    }
                    dispatch(getNewsReactionsSuccess(tmpNewsReactions, id))
                } else {
                    dispatch(reactionToNewsError(id))
                }
            })
            .catch((error: Error) => {
                dispatch(reactionToNewsError(error.message))
            })
    }
}

// SET FILTERS

export const setFilters = (filters: ActivitiesFiltersProps) => {
    return {
        type: Actions.SET_FILTERS,
        filters,
    }
}

// ADD COMMENT

export const addComment = (payload: NewsAddCommentActionPayload) => {
    return {
        type: Actions.ADD_COMMENT,
        payload,
    }
}

// SET ACTIVE TAB

export const setActiveTab = (activeTab: NewsTabBarId) => {
    return {
        type: Actions.SET_ACTIVE_TAB,
        activeTab: activeTab,
    }
}

// SET NEWS DETAILS

export const setNewsDetails = (newsDetails: News) => {
    return {
        type: Actions.SET_NEWS_DETAILS,
        newsDetails,
    }
}

// ORDER RANDOM NEWS

export const orderRandomNews = () => {
    return {
        type: Actions.ORDER_RANDOM_NEWS,
    }
}

// UPDATE TOTAL REACTIONS

export const updateTotalReactions = (payload: NewsUpdateTotalReactionsActionPayload) => {
    return {
        type: Actions.UPDATE_TOTAL_REACTIONS,
        payload,
    }
}

export enum ReactionOperation {
    ADD = 'add',
    REMOVE = 'remove',
}

export const reactionToNews = (id: string, reaction?: NewsReactionType, stop?: boolean) => {
    return (dispatch, getState) => {
        dispatch(reactionToNewsRequest(id))
        const project = getState()[NEWS_REDUCER_NAMESPACE].newsList.find((n) => n.id === id)
        const userReaction = project.reactions.userReaction
        let reactionOperation = ReactionOperation.ADD
        let newReaction
        if (!stop) {
            if (!!reaction && userReaction === reaction)
                reactionOperation = ReactionOperation.REMOVE
            if (!!reaction && !!userReaction && userReaction !== reaction) {
                newReaction = reaction
                reaction = userReaction
                reactionOperation = ReactionOperation.REMOVE
            }
        }
        r360Api
            .ReactionToNews({ reaction, reactionOperation }, id)
            .then((res) => {
                if (res && res.data && !res.data.output) {
                    if (newReaction) {
                        dispatch(reactionToNews(id, newReaction, true))
                    } else {
                        dispatch(getNewsReactions(id))
                    }
                } else {
                    commentsActions.commentsFailure(res.data.output.payload.message)
                    dispatch(reactionToNewsError(id))
                }
            })
            .catch((error) => {
                dispatch(
                    commentsActions.commentsFailure(error.response?.data?.message || error.message)
                )
                dispatch(reactionToNewsError(id))
            })
    }
}

// COPY LINK TO CLIPBOARD

export const copyLinkToClipboard = (success: string) => {
    return {
        type: Actions.COPY_LINK_TO_CLIPBOARD_SUCCESS,
        toastList: [
            {
                title: 'Success',
                text: success,
            },
        ],
    }
}
